import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import { ReactComponent as UndoIcon } from '../../assets/images/icons/i-undo.svg'
import { ReactComponent as RedoIcon } from '../../assets/images/icons/i-redo.svg'

import { updateCurrentSettingId } from '../../store/actions/settings.actions'
import CircleButton from '../Common/Buttons/CircleButton/CircleButton'
import Tooltip from '../Tooltip/Tooltip'

class StateControls extends Component {
  static propTypes = {
    imageSrc: PropTypes.string.isRequired,
    currentSettingId: PropTypes.number.isRequired,
    settingLimitId: PropTypes.number.isRequired,
    lastSettingId: PropTypes.number.isRequired,
    updateCurrentSettingId: PropTypes.func.isRequired,
  }

  undo = () => {
    const {
      currentSettingId,
      updateCurrentSettingId
    } = this.props

    updateCurrentSettingId(currentSettingId - 1)
  }

  redo = () => {
    const {
      currentSettingId,
      updateCurrentSettingId
    } = this.props

    updateCurrentSettingId(currentSettingId + 1)
  }

  render() {
    const { 
      imageSrc, 
      currentSettingId, 
      settingLimitId, 
      lastSettingId 
    } = this.props

    return (
      <div className="state-controls">
        <div className="state-controls__button">
          <Tooltip
            placement="top"
            translationKey='titles.undo'
            overlayClassName={!imageSrc || currentSettingId - settingLimitId === 0 ? 'tooltip_hidden' : ''}
          >
            <CircleButton
              onClick={this.undo}
              disabled={!imageSrc || currentSettingId - settingLimitId === 0}
            >
              <UndoIcon />
            </CircleButton>
          </Tooltip>
        </div> 
        <div className="state-controls__button">
          <Tooltip
            placement="top"
            translationKey='titles.redo'
            overlayClassName={!imageSrc || lastSettingId - currentSettingId === 0 ? 'tooltip_hidden' : ''}
          >
            <CircleButton
              onClick={this.redo}
              disabled={!imageSrc || lastSettingId - currentSettingId === 0}
            >
              <RedoIcon />
            </CircleButton>
          </Tooltip>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({
  imageStore: {
    imageSrc
  },
  settingsStore: { 
    currentSettingId, 
    settingLimitId, 
    lastSettingId 
  },
}) => ({
  imageSrc,
  currentSettingId,
  settingLimitId,
  lastSettingId,
})

const mapDispatchToProps = (dispatch) => ({
  updateCurrentSettingId: (id) => dispatch(updateCurrentSettingId(id)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StateControls)
